import { createAsyncThunk } from "@reduxjs/toolkit";
import { UploadFreightClaimAttachmentFile } from "../interface";
import {
  getFreighClaimProducts,
  getReceiveDetails,
  getStoreCreditDetails,
  postPoCreate,
  uploadFreightClaimAttachmentsCall
} from "src/api/sp";

export const uploadFreightClaimAttachments = createAsyncThunk(
  "uploadFreightClaimAttachments",
  (fcUploadAttachmentPayload: UploadFreightClaimAttachmentFile) =>
    uploadFreightClaimAttachmentsCall(fcUploadAttachmentPayload)
);

export const postEditFreightClaim = createAsyncThunk(
  "postEditFreightClaim",
  (freightClaimPayload: object) => postPoCreate(freightClaimPayload)
);

export const getProductsForFC = createAsyncThunk(
  "getProductsForFC",
  ({
    receivingDocId,
    referenceId,
    storeId
  }: {
    receivingDocId: number;
    referenceId: string;
    storeId: string;
  }) => getFreighClaimProducts({ receivingDocId, referenceId, storeId })
);

export const fetchTransferDetails = createAsyncThunk(
  "fetchTransferDetails",
  ({
    docId,
    storeId,
    type
  }: {
    docId: string;
    storeId: string;
    type: string;
  }) => getReceiveDetails("", type, docId, storeId)
);
export const getStoreCreditDetailsForFC = createAsyncThunk(
  "getStoreCreditDetailsForFC",
  ({
    storeId,
    referenceTransfer,
    type
  }: {
    storeId: string;
    referenceTransfer: number;
    type: string;
  }) => getStoreCreditDetails({ storeId, referenceTransfer, type })
);
